export type CommissionsTranslation = {
  amount: string;
  approved: string;
  commissionMonth: string;
  commissionMonthFrom: string;
  commissionMonthTo: string;
  createdFrom: string;
  createdTo: string;
  customer: string;
  empty: string;
  historyError: string;
  historyLoading: string;
  offer: string;
  paymentStatus: {
    paid: string;
    toBePaid: string;
  };
  paymentStatusLabel: string;
  potential: string;
  potentialError: string;
  process: string;
  processStatus: string;
  profit: string;
  startedAt: string;
  status: string;
};

export const commissionsTranslation: CommissionsTranslation = {
  amount: 'Kwota',
  approved: 'Zatwierdzone w tym miesiącu',
  commissionMonth: 'Miesiąc prowizji',
  commissionMonthFrom: 'Miesiąc prowizji od',
  commissionMonthTo: 'Miesiąc prowizji do',
  createdFrom: 'Rozpoczęty po',
  createdTo: 'Rozpoczęty przed',
  customer: 'Klient',
  empty: 'Brak potencjalnych prowizji.',
  historyError: 'Nie udało się pobrać historii prowizji.',
  historyLoading: 'Ładowanie historii prowizji',
  offer: 'Oferta',
  paymentStatus: {
    paid: 'Wypłacono',
    toBePaid: 'Do wypłaty',
  },
  paymentStatusLabel: 'Status płatności',
  potential: 'Aktualna potencjalna prowizja',
  potentialError: 'Nie udało się pobrać potencjalnych prowizji.',
  process: 'Proces',
  processStatus: 'Status procesu',
  profit: 'Zysk oferty',
  startedAt: 'Data rozpoczęcia',
  status: 'Status',
};
